// extracted by mini-css-extract-plugin
export default {"category":"Category_category__aUYb0","container":"Category_container__rEwGV","row":"Category_row__oYx1A","title":"Category_title__uY8x+"};